import React from 'react'
import { Tag } from 'antd'

import Styles from './ExamineeInfoModal.module.scss'
import { formatQsRankText, hasSchoolTagDisplay } from '../../common/inputSuggestConstants'

function SchoolTagSummary (props) {
  const { schoolTag, inline = false } = props

  if (!hasSchoolTagDisplay(schoolTag)) {
    return null
  }

  const qsText = formatQsRankText(schoolTag)
  const wrapClassName = inline
    ? `${ Styles.schoolTagWrap } ${ Styles.schoolTagInline }`
    : Styles.schoolTagWrap

  return (
    <div className={ wrapClassName }>
      {
        schoolTag.tags?.map((tag) => (
          <Tag key={ tag } color="blue">{ tag }</Tag>
        ))
      }
      { qsText ? <Tag color="blue">{ qsText }</Tag> : null }
    </div>
  )
}

export default SchoolTagSummary
